/**
 * The two numbers every RTL / GUC rate card shows (pricing-scenario-sizers.md,
 * "DISPLAY CHANGE", owner 2026-10-08 — "this is backwards"):
 *
 *   Required coupon (HEADLINE) = requiredBaseRate + accountSpread
 *                                → what the BORROWER pays
 *   Buy rate (sub-line)        = requiredBaseRate
 *                                → what the investor buys at, always BELOW the
 *                                  coupon by the correspondent's spread
 *
 * The old card headlined `requiredBaseRate` with a buy rate above it. Never
 * headline `requiredBaseRate`, and never show a buy rate above the coupon.
 *
 * Backend `1094c5d` returns `requiredCoupon` and redefines `buyRate` as the
 * required base. A response from before that commit has no `requiredCoupon`
 * and its `buyRate` was base + spread (today's coupon), so both helpers read it
 * that way rather than flipping the two numbers on an older build.
 *
 * LQ house quotes (`lqMode` / `quoteMode: "coupon"`) show the coupon only.
 */

const num = (v) => (v == null || v === "" || Number.isNaN(Number(v)) ? null : Number(v));

/** The headline: what the borrower pays (decimal fraction). */
export const rtlRequiredCoupon = (rate) => {
  if (!rate) return null;
  if (num(rate.requiredCoupon) != null) return num(rate.requiredCoupon);
  // Pre-1094c5d: buyRate was base + spread, i.e. the coupon.
  return num(rate.buyRate) ?? num(rate.requiredBaseRate);
};

/** The sub-line: what the investor buys at (decimal fraction), or null. */
export const rtlBuyRate = (rate) => {
  if (!rate) return null;
  if (rate.lqMode || rate.quoteMode === "coupon") return null;
  if (num(rate.requiredCoupon) != null)
    return num(rate.buyRate) ?? num(rate.requiredBaseRate);
  // Pre-1094c5d: the investor's rate was the required base.
  return num(rate.buyRate) != null ? num(rate.requiredBaseRate) : null;
};
